import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { ModalService } from '@malirang/front-share';
import { ClickOutside } from 'ngxtension/click-outside';

@Component({
  selector: 'app-info-modal',
  imports: [CommonModule, ClickOutside],
  templateUrl: './info.modal.html',
  styleUrl: './info.modal.scss',
})
export default class InfoModal {
  readonly modalService = inject(ModalService);

  /**
   * @name close
   * @description 팝업 닫기
   * @param {Event} ev
   */
  close(ev?: Event): void {
    ev?.preventDefault();
    ev?.stopPropagation();
    this.modalService.close();
  }
}
